<template>
  <div class="course-desc">
    <!-- <p>课程简介</p>
    <div class="course-desc-info">{{ info.summary }}</div> -->
    <p>课程介绍</p>
    <div class="course-desc-info" v-html="info.description"></div>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
.course-desc {
  padding: 32px 24px;
  > p {
    font-weight: bold;
    font-size: 16px;
    color: #262626;
    line-height: 22px;
    margin-bottom: 24px;
  }
  .course-desc-info {
    margin-bottom: 36px;
    &:last-child {
      margin-bottom: 0;
    }
    ::v-deep img {
      max-width: 100%;
    }
  }
}
</style>
